import { Alert, AlertIcon, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { clearImpersonatedPersonId, getImpersonatedPersonId } from "../local-storage/impersonated-person";
import { useAppSelector } from "../redux/hooks";

export const ImpersonationBanner = () => {
  const { t } = useTranslation();
  const impersonatedEmail = useAppSelector((state) => {
    const authState = state.authState.state;
    return authState && authState.type !== "LoggedOut" ? authState.me.email : null;
  });

  if (!getImpersonatedPersonId()) return null;

  return (
    <Alert status="info" flexShrink={0}>
      <AlertIcon />
      {impersonatedEmail ? (
        <>
          {t("You are impersonating user")}:&nbsp;<b>{impersonatedEmail}</b>
        </>
      ) : (
        t("You are impersonating another user")
      )}
      <Button
        size="sm"
        ml="3"
        variant="solid"
        colorScheme="blue"
        onClick={() => {
          clearImpersonatedPersonId();
          window.location.reload();
        }}
      >
        {t("Stop")}
      </Button>
    </Alert>
  );
};
